
import Vue from 'vue';
/* eslint-disable */
/** 判断微信环境 */
function inWeiXin () {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * 判断安卓或者苹果
 * return String 'Android' ,'IOS' ,'PC系统'
 * */
function phoneType () {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'Android'
  } else if (isiOS) {
    return 'IOS'
  } else {
    return 'PC'
  }
}
/** 动态添加meta */
function setMeta () {
  if (!document.querySelector('meta[content="upgrade-insecure-requests"]')) {
    var oMeta = document.createElement('meta')
    oMeta.setAttribute('http-equiv', 'Content-Security-Policy')
    oMeta.setAttribute('content', 'upgrade-insecure-requests')
    document.getElementsByTagName('head')[0].appendChild(oMeta)
  }
}

/** 环境判断 */
function environment () {
  var devCondition = window.top.location.href.search(/test/) > -1
  var localCondition = window.top.location.href.indexOf('localhost') > -1
  if (!devCondition && !localCondition) {
    return true
  } else {
    return false
  }
}

// 设置手机app环境适配
function adaptive () {
  (function (doc, win) {
    // 分辨率适配Resolution Adaptive
    var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function () {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return
        docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
      }
    // console.log("设置html的font-size")
    // Abort if browser does not support addEventListener
    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false);

    // 一物理像素在不同屏幕的显示效果不一样。要根据devicePixelRatio来修改meta标签的scale,要注释上面的meta标签
    (function () {
      return
      var dpr = scale = 1
      var isIPhone = win.navigator.appVersion.match(/iphone/gi)
      var devicePixelRatio = win.devicePixelRatio
      if (isIPhone) {
        // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
        if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
          dpr = 3
        } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
          dpr = 2
        } else {
          dpr = 1
        }
      } else {
        // 其他设备下，仍旧使用1倍的方案
        dpr = 1
      }
      scale = 1 / dpr

      //
      var metaEl = ''
      metaEl = doc.createElement('meta')
      metaEl.setAttribute('name', 'viewport')
      metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no')
      if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(metaEl)
      } else {
        var wrap = doc.createElement('div')
        wrap.appendChild(metaEl)
        doc.write(wrap.innerHTML)
      }
    })()
  })(document, window)
}
// 设置官网环境适配
function websiteAdaptive () {
  var userAgentInfo = navigator.userAgent
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod']
  var flag = true
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  if (flag) {
    var winWidth = document.documentElement.offsetWidth ||

      document.body.offsetWidth

    winWidth = winWidth < 1366 ? 1366 : winWidth

    var oHtml = document.getElementsByTagName('html')[0]

    oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'

    window.addEventListener('resize', function () {
      var winWidth = document.documentElement.offsetWidth || document.body.offsetWidth

      winWidth = winWidth < 1400 ? 1400 : winWidth

      var oHtml = document.getElementsByTagName('html')[0]

      oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
    })
  } else {
    (function (doc, win) {
      // 分辨率适配Resolution Adaptive
      var docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        recalc = function () {
          var clientWidth = docEl.clientWidth
          // console.log(clientWidth)
          if (!clientWidth) return
          docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        }
      // console.log("设置html的font-size")
      // Abort if browser does not support addEventListener
      if (!doc.addEventListener) return
      win.addEventListener(resizeEvt, recalc, false)
      doc.addEventListener('DOMContentLoaded', recalc, false);

      // 一物理像素在不同屏幕的显示效果不一样。要根据devicePixelRatio来修改meta标签的scale,要注释上面的meta标签
      (function () {
        return
        var dpr = scale = 1
        var isIPhone = win.navigator.appVersion.match(/iphone/gi)
        var devicePixelRatio = win.devicePixelRatio
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2
          } else {
            dpr = 1
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1
        }
        scale = 1 / dpr

        //
        var metaEl = ''
        metaEl = doc.createElement('meta')
        metaEl.setAttribute('name', 'viewport')
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no')
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl)
        } else {
          var wrap = doc.createElement('div')
          wrap.appendChild(metaEl)
          doc.write(wrap.innerHTML)
        }
      })()
    })(document, window)
  }
}
function timestampToTime(timestamp, hms = true, getDetail,isD=true,) {
  // console.log(timestamp,"----")
  if (!timestamp) return timestamp;
  if ((timestamp + "").length === 10) timestamp = timestamp * 1000;

  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = change(date.getDate());
  let h = change(date.getHours());
  let m = change(date.getMinutes());
  let s = change(date.getSeconds());
  if (getDetail) {
    const detailDate = {
      Y: Y,
      M: M,
      D: D,
    };
    if (hms) {
      detailDate.h = h;
      detailDate.m = m;
      detailDate.s = s;
    }
    return detailDate;
  }
  if (hms) {
    return `${ Y }-${ M }-${ D } ${ h }:${ m }:${ s }`;
  }
  if (!isD){
    return `${ Y }-${ M }`
  }
  return `${ Y }-${ M }-${ D }`;
}
function timestampTime(timestamp,hms = true,day=true) {
  if (!timestamp) return timestamp;
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + (day?'-':'');
  let D = change(date.getDate()) + ' ';
  let h = change(date.getHours()) + ':';
  let m = change(date.getMinutes())+':';
  let s = change(date.getSeconds());
  if (!day) return Y + M;
  if (!hms) return Y + M + D
  return Y + M + D+h+m+s ;
}
function change(t) {
  if (t < 10) {
    return "0" + t;
  } else {
    return t;
  }
}

// 校验字符串是否为数字
function checkStrIsNum(str) {
  const reg = /^\d+$/g;
  const result = reg.test(str);
  reg.lastIndex = 0;
  return result;
}

function moreTime() {
  let newdate = new Date().getTime()
  let olddate = localStorage.getItem('inspection_time')

  if(newdate-olddate<18000000){
    return true
  }else {
    return false
  }
}

function dataToTimestamp(date, type) {
  if(!date || !date.trim()) return '';
  let _date = date.replace(/-/g, '/');
  if (type === 'start' && (_date.indexOf(' 00:00:00') === -1)) {
    _date += ' 00:00:00';
  } else if(type === 'end' && (_date.indexOf(' 23:59:59') === -1)) {
    _date += ' 23:59:59';
  }
  return new Date(_date).getTime();
}

// 屏幕尺寸变化监听

function screenResize(cb) {
  let windowWidth = window.innerWidth;
  const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  window.addEventListener(resizeEvt, () => {
    const newWindowWidth = window.innerWidth;
    if (windowWidth !== newWindowWidth) {
      cb && cb();
      windowWidth = newWindowWidth;
    }
  });
}

// 全局loading显示
function globleLoading() {
  let _loadingConfig = {
    countLoading: 0,
    loading: '',
  };
  return {
    show() {
      if (_loadingConfig.countLoading <= 0) {
        _loadingConfig.loading = Vue.$loading.show({
          width: 50,
          height: 50,
          color: '#2d8cf0',
          zIndex: 1030,
        });
      }
      _loadingConfig.countLoading += 1;
    },
    // 配合其他判断条件的隐藏，手动_loadingConfig.countLoading -= 1;详细看request.js
    hide() {
      if (_loadingConfig.countLoading <= 0) {
        // Vue.$loading.show();
        // Vue.$loading.hide();
        _loadingConfig.loading && _loadingConfig.loading.hide();
      }
    },
    loadingConfig: _loadingConfig,
    // 自己调用_loadingConfig.countLoading -= 1来隐藏
    selfHide() {
      _loadingConfig.countLoading -= 1;
      this.hide();
    },
  }
}

function getObjDate(date) {
  if (date) return new Date(date);
  return new Date();
}

function getTimestamp(time, type) {

  if(time.length<2){
    return parseInt(time)
  }

  if(typeof time === 'object') {
    if (type === 'start') {
      time.setHours(0);
      time.setMinutes(0);
      time.setSeconds(0);
    } else if (type === 'end') {
      time.setHours(23);
      time.setMinutes(59);
      time.setSeconds(59);
    }
    return parseInt(time.getTime() / 1000);
  }
  else if (typeof time === 'number') {
    if ((time + '').length === 13) return parseInt(time / 1000);
    else return time;
  }
  else return parseInt(dataToTimestamp(time, type) / 1000);
}

function checkNumReg(num) {
  const regNum = /^[0-9]+$/;
  const result = regNum.test(num);
  regNum.lastIndex = 0;
  return result;
}

function checkNumDecimalReg(num) {
  const regNum = /^([0-9]|[1-9]\d+)(\.\d{2})?$/;
  const result = regNum.test(num);
  regNum.lastIndex = 0;
  return result;
}

// 格式化成北京时间xxxx/xx/xx xx:xx:xx
// typeT: true：土耳其时间格式为 时分 日月年顺序，false：普通顺序时间
// 传入时间戳:time ，或者 tz: 时区默认8==>东八区
// returnTimestamp 为 true 时返回时间戳
function handleBJTime(returnTimestamp = false, time = new Date().getTime(), typeT, tz = 8) {
  if (!time) return time;
  if (time.toString().length === 10) time = time * 1000;
  let getTZODate = '';
  if (typeof time === 'number') {
    getTZODate = handleTimeDate(time, tz);
  } else if (typeof time === 'string') {
    getTZODate = handleTimeDateStr(time, tz);
  }
  if (returnTimestamp) return getTZODate.getTime();
  const getYear = getTZODate.getFullYear();
  const getMonth = addZero(getTZODate.getMonth() + 1);
  const getDate = addZero(getTZODate.getDate());
  const getHour = addZero(getTZODate.getHours());
  const getMinute = addZero(getTZODate.getMinutes());
  const getSecond = addZero(getTZODate.getSeconds());
  if (!typeT) return `${getYear}/${getMonth}/${getDate} ${getHour}:${getMinute}:${getSecond}`;
  else return `${getHour}:${getMinute}:${getSecond} ${getDate}/${getMonth}/${getYear}`;
}

// 返回转换指定时区的new Date对象
// time: 传入与时间戳，默认当前时间，tz：指定时区，默认东8区
function handleTimeDate(time = new Date().getTime(), tz = 8) {
  if (!time) return time;
  if (time.toString().length === 10) time = time * 1000;
  return new Date(time * 1 + new Date().getTimezoneOffset() * 60 * 1000 + tz * 3600 * 1000)
}
// 传入的time是字符串类型的时候
function handleTimeDateStr(time, tz = 8) {
  if (!time) return time;
  const tzTime = new Date().getTimezoneOffset() * 60 * 1000 + tz * 3600 * 1000;
  return new Date(new Date(time).getTime() + tzTime + tzTime);
}
// 补0 默认补两位，默认往数字前面补
function addZero(num, numSize = 2, type = "before") {
  if (!num && num !== 0) return num;
  let getNum = num.toString();
  while (getNum.length < numSize) {
    if (type === 'before') {
      getNum = `0${getNum}`;
    } else {
      getNum += '0';
    }
  }
  return getNum;
}
function checkSameData(Arr,type){
  // Arr 要处理的数组
  // type 单个处理条件

  var newData ={};//新的对象
  var newArr =[];// 输出的新数组

  Arr.forEach((item)=>{
    if(!newData[item[type]]){
      newArr.push({
        accurate: item[type],
        list:[item]
      });
      newData[item[type]] = item;
    }else {
      newArr.forEach((ite)=>{
        if(ite.accurate == item[type]){
          ite.list.push(item)
        }
      })
    }

  });

  return newArr
}


var toHHmmss = function (date) {
  var data =date *1000
  var s;
  var hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = (data % (1000 * 60)) / 1000;
  s = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
  return s;
};


//去除左右两边空格
function trim(s) {
  if (!s) return ''
  return s.replace(/(^\s*)|(\s*$)/g, "");
}
// 深拷贝对象
function deepClone(obj) {
  if (obj === null) return null;
  if (typeof obj !== 'object') return obj;
  if (obj instanceof Date) {
    let date = new Date();
    date.setTime(obj.getTime());
    return date;
  }
  if (obj instanceof RegExp) {
    let re = new RegExp(obj.source);
    re.lastIndex = obj.lastIndex;
    return re;
  }
  let newObj = new obj.constructor();
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[key] = deepClone(obj[key]);
    }
  }
  return newObj;
}

//限制上传图片大小
function upImgSize(e, size = 2) {
  let flag = false;
  let file = e.target.files[0];
  if (file.size <= 1024 * 1024 * size) {
    flag = true;
  } else {
    flag = false;
  }
  console.log('限制上传图片大小--该图片大小为：' + (file.size / (1024 * 1024)).toFixed(2) + 'MB');
  return flag
}

// 获取图片宽高
function getImageSize(url) {
  return new Promise(function (resolve, reject) {
    let image = new Image();
    image.onload = function () {
      resolve({
        width: image.width,
        height: image.height
      });
    };
    image.onerror = function () {
      reject(new Error('error'));
    };
    image.src = URL.createObjectURL(url);
  });
}

//  秒数转化为时分秒
function formatSeconds(value,sec = true) {
  if (parseInt(value) === 0) return '/'
  //  秒
  let second = parseInt(value)
  //  分
  let minute = 0
  //  小时
  let hour = 0
  //  天
  //  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = parseInt(second / 60)
    //  获取秒数，秒数取佘，得到整数秒数
    second = parseInt(second % 60)
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = parseInt(minute / 60)
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = parseInt(minute % 60)
      //  如果小时大于24，将小时转换成天
      //  if (hour > 23) {
      //    //  获取天数，获取小时除以24，得到整天数
      //    day = parseInt(hour / 24)
      //    //  获取天数后取余的小时，获取小时除以24取余的小时
      //    hour = parseInt(hour % 24)
      //  }
    }
  }

  let result = ''
  if (sec){
    result = parseInt(second) + '秒'
  }

  if (minute > 0) {
    result = '' + parseInt(minute) + '分' + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + '小时' + result
  }
  return result
}

//去除换行
function clearBr(key)
{
  key = key.replace(/<\/?.+?>/g,"");
  key = key.replace(/[\r\n]/g, "");
  return key;
}
// 换行替换成英文逗号,并去空
function clearBrAndTrim(text) {
  let replaceText = text.replace(/\n/g,',')
  let textArr = replaceText.split(',')
  textArr = textArr.filter(function (s) {
    return s && s.trim();
  })
  return textArr.join(',')
}


function getNowdate(baseDate,n) {
  let date_now = baseDate,
    year = date_now.getFullYear(), //获取当前时间的年份
    month = date_now.getMonth() + 1, //获取当前时间的月份
    day = date_now.getDate(), //获取当前时间是几号
    num, date_end, days; // 备用变量 后面要用

  // 以下开始计算n个月后的日期
  month = month + n
  num = parseInt(month / 12);
  if (month > 12) {
    num = month % 12 == 0 ? num - 1 : num; //注：month % 12 == 0时,num-1，若12月的12个月后其实是明年的12月 num应是1 不是2
    year = year + num; //月份大于12个月 年份+num
    month = month % 12 == 0 ? 12 : parseInt(month) % 12; //大于12对12取余数，余数为0时=12月
  }

  //考虑到如果当前日期是【2022-03-31】半年后的9月却只有30天
  date_end = new Date(year, month, 0); //这里可以拿到n个月后的最后一天的日期
  days = date_end.getDate(); //n个月后的最后一天是几号
  if (day > days) {
    day = days //若n个月后没有31号，就取那个月的最后一天，例如：2022-03-31 6个月后只有 2022-09-30
  }

  //最后优化下时间格式
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  return year + '-' + month + '-' + day
}

function getBeforeMonthFirstDayTimestamp(num = 0){
  // @num 0=本月，1=上个月，2=上上个月 以此类推
  const date = new Date();
  date.setMonth(date.getMonth() - num);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date.getTime() / 1000;
}
function getLastDayOfMonthTimestampSimplified() {
  // 获取当前日期
  const now = new Date();

  // 获取当前年份和月份
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1

  // 创建一个指向“下个月0号”的Date对象，实际上这会被解析为当前月的最后一天
  const lastDayOfMonth = new Date(year, month, 0);

  // 转换为时间戳（毫秒）
  return lastDayOfMonth.getTime();
}

function getTimeZoneTime(offsetInHours) {
  // 创建一个新的Date对象，表示当前的UTC时间
  let utcDate = new Date(Date.UTC(
    new Date().getUTCFullYear(),
    new Date().getUTCMonth(),
    new Date().getUTCDate(),
    new Date().getUTCHours(),
    new Date().getUTCMinutes(),
    new Date().getUTCSeconds(),
    new Date().getUTCMilliseconds()
  ));

  // 将UTC时间转换为东三区时间
  let localTime = new Date(utcDate.getTime() + (offsetInHours * 60 * 60 * 1000));

  // 返回格式化的日期字符串（你可以根据需要自定义格式）
  return localTime
}
// 传入type值 1-24小时 2-本周 3-上周 4-本月 5-上月 6-上上月，返回开始时间戳和结束时间戳 秒单位
function getTimeRange(type) {
  let startTime = 0, endTime = 0;

  // 参数验证
  if (typeof type !== 'number' || type < 1 || type > 6 || !Number.isInteger(type)) {
    throw new Error('Invalid type parameter. Expected integer between 1 and 6.');
  }

  const now = new Date();

  const setTimeToStartOfDay = (date) => {
    date.setHours(0, 0, 0, 0);
  };

  const setTimeToEndOfDay = (date) => {
    date.setHours(23, 59, 59, 999);
  };

  switch (type) {
    case 1: // 24小时
      endTime = Math.floor(now.getTime() / 1000);
      startTime = endTime - 24 * 60 * 60; // 修正为秒单位
      break;
    case 2: // 本周
      const dayOfWeek = now.getDay();
      const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() + diffToMonday);
      setTimeToStartOfDay(startOfWeek);
      startTime = Math.floor(startOfWeek.getTime() / 1000);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      setTimeToEndOfDay(endOfWeek);
      endTime = Math.floor(endOfWeek.getTime() / 1000);
      break;
    case 3: // 上周
      const lastWeekDay = now.getDay();
      const diffToLastMonday = lastWeekDay === 0 ? -13 : -6 - lastWeekDay;
      const startOfLastWeek = new Date(now);
      startOfLastWeek.setDate(now.getDate() + diffToLastMonday);
      setTimeToStartOfDay(startOfLastWeek);
      startTime = Math.floor(startOfLastWeek.getTime() / 1000);

      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      setTimeToEndOfDay(endOfLastWeek);
      endTime = Math.floor(endOfLastWeek.getTime() / 1000);
      break;
    case 4: // 本月
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      setTimeToStartOfDay(startOfMonth);
      startTime = Math.floor(startOfMonth.getTime() / 1000);

      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      setTimeToEndOfDay(endOfMonth);
      endTime = Math.floor(endOfMonth.getTime() / 1000);
      break;
    case 5: // 上月
      const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      setTimeToStartOfDay(startOfLastMonth);
      startTime = Math.floor(startOfLastMonth.getTime() / 1000);

      const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);
      setTimeToEndOfDay(endOfLastMonth);
      endTime = Math.floor(endOfLastMonth.getTime() / 1000);
      break;
    case 6: // 上上月
      const startOfLastLastMonth = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      setTimeToStartOfDay(startOfLastLastMonth);
      startTime = Math.floor(startOfLastLastMonth.getTime() / 1000);

      const endOfLastLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 0);
      setTimeToEndOfDay(endOfLastLastMonth);
      endTime = Math.floor(endOfLastLastMonth.getTime() / 1000);
      break;
  }

  return { startTime, endTime };
}


// 转千分位
function numberWithCommas(x) {
  if (!x) return '0'
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
//
/**
 * 将带有千分位的字符串转换为数字
 * @param {string} str - 输入的字符串
 * @returns {number} - 转换后的数字
 * @throws {Error} - 输入格式无效时抛出错误
 */
function withCommasToNumber(str) {
  // 检查输入字符串是否为空或仅包含无效字符
  if (!str || !str.trim()) {
    throw new Error('Input string is empty or invalid');
  }

  // 去除首尾空白字符
  const trimmedStr = str.trim();

  // 检查是否已经是有效的数字字符串
  if (/^-?\d+(\.\d+)?$/.test(trimmedStr)) {
    return parseFloat(trimmedStr);
  }

  // 替换所有逗号
  const result = parseFloat(trimmedStr.replace(/,/g, ''));

  // 检查转换结果是否为有效数字
  if (isNaN(result)) {
    throw new Error('Invalid number format');
  }

  return result;
}

// 格式化date YYYY-MM-DD HH:mm:ss
// date 为Date对象
function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
  console.log(date)
  if (!date) return date;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}

// 数字转K、M单位
function scientificToNumber(num) {
  if (num === null || num === undefined) {
    return '0';
  }
  if (num >= 1000000) {
    const value = num / 1000000;
    return value % 1 === 0 ? value + 'M' : value.toFixed(2) + 'M';
  } else if (num >= 1000) {
    const value = num / 1000;
    return value % 1 === 0 ? value + 'K' : value.toFixed(2) + 'K';
  } else {
    return num.toString();
  }
}

export default {

  inWeiXin: inWeiXin,
  setMeta: setMeta,
  environment: environment,
  adaptive: adaptive,
  websiteAdaptive: websiteAdaptive,
  phoneType: phoneType,
  timestampToTime:timestampToTime,
  timestampTime:timestampTime,
  checkStrIsNum,
  moreTime,
  dataToTimestamp,
  screenResize,
  globleLoading,
  getObjDate,
  getTimestamp,
  checkNumReg,
  checkNumDecimalReg,
  change,
  handleBJTime,
  handleTimeDate,
  handleTimeDateStr,
  addZero,
  checkSameData,
  toHHmmss,
  trim,
  deepClone,
  upImgSize,
  formatSeconds,
  getImageSize,
  clearBr,
  clearBrAndTrim,
  getNowdate,

  getBeforeMonthFirstDayTimestamp,
  getTimeZoneTime,
  getLastDayOfMonthTimestampSimplified,
  getTimeRange,

  numberWithCommas,
  withCommasToNumber,

  formatDate,
  scientificToNumber,
}



// WEBPACK FOOTER //
// ./src/js/until.js